<template>
    <div class="main">
        <myheader></myheader>
        <div class="mains">
            <div class="lanmu">
                <div class="top">群接龙</div>
                <div class="sub flex">
                    <p></p>
                    <div class="caidan">
                        <el-button  @click="scroll(-1)" type="info" size="mini" icon="el-icon-arrow-left" class="left-icon"></el-button>
                        <div class="cons flex" ref="wrapperCon" @scroll="handleScroll">
                            <li v-for="(item, index) in pinpai" :key="index" :class="{ active: index === currentIndex }" @click="toggleColor(index, item.id)">{{ item.name }}</li>
                        </div>
                        <el-button  @click="scroll(1)" type="info" size="mini" icon="el-icon-arrow-right" class="right-icon"></el-button>
                    </div>
                </div>
            </div>
            <div class="content flex">
                <div class="xuanx">
                    <div class="luodi flex">
                        <img src="/static/images/address_icon.png" alt="">
                        <p>落地省份</p>
                    </div>
                    <div class="sf">
                        <el-radio-group v-model="selectedRadio" @input="sfInput">
                            <el-radio label="全部需求">全部需求</el-radio>
                            <el-radio :label="item.city" v-for="item in sfRadio" :key="item.city">{{  item.city_name }}</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="contents">
                    <div class="caidans">
                        <div class="plei">
                            <el-button  @click="scrollPl(-1)" type="info" size="mini" icon="el-icon-arrow-left" class="left-icon"></el-button>
                            <div class="quanbu" :class="{ active: currentIndexQ }" @click="toggleColorQ()">全部</div>
                            <div class="cons flex" ref="wrapperConPl" @scroll="handlePlScroll">
                                <li v-for="(item, index) in pinlei" :key="index" :class="{ active: index === currentIndexP }" @click="toggleColorP(index, item.goods_id)">
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item.goods_name }}</div>
                                        <div>{{ item.goods_name }}</div>
                                    </el-tooltip>
                                </li>
                            </div>
                            <el-button  @click="scrollPl(1)" type="info" size="mini" icon="el-icon-arrow-right" class="right-icon"></el-button>
                        </div>
                        <el-button size="medium" @click="chujiabtn">出价记录</el-button>
                    </div>
                    <!-- 接龙列表 -->
                    <div class="tableWrap">
                        <el-table
                            v-loading="loading"
                            element-loading-text="加载中"
                            :data="tableData"
                            style="width: 100%"
                            height="550">
                            <el-table-column
                            prop="brand_name"
                            label="类别"
                            width="90">
                            <template slot="header" slot-scope="scope">
                                <el-popover class="filterHeader"
                                    v-model="lbVisible"
                                    placement="bottom"
                                    trigger="click">
                                    <div class="pop-wrap">
                                        <div class="cleck-wrap">
                                            <el-input class="btn-search"
                                                placeholder="搜索"
                                                prefix-icon="el-icon-search"
                                                v-model="leibiekeyInput"
                                                @input="leibiechangeInput"
                                                clearable
                                                size="small">
                                            </el-input>
                                            <div class="check-box">
                                                <div class="sf scrollBox">
                                                    <el-radio-group v-model="selectedleibieRadio" @input="leibieInput">
                                                        <el-radio :label="item.cate_id" v-for="item in leibieRadio" :key="item.cate_id">{{  item.cate_name }}（ {{ item.total_num }} ）</el-radio>
                                                    </el-radio-group>
                                                </div>
                                            </div>
                                            <div class="footerWrap">
                                                <div class="btnWrap">
                                                    <el-button size="medium" @click="lbCancel" class="nl-need-cancel-btn">取消</el-button>
                                                    <el-button size="medium" @click="lbSure" class="nl-need-sure-btn">确定</el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="reference" style="cursor: pointer;">类别<svg t="1782501535717" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7766" width="200" height="200"><path d="M855.342766 151.46262c-6.056949-11.851932-18.984377-19.393699-33.219589-19.393699L101.903901 132.068921c-14.360056 0-27.412326 7.704472-33.396621 19.744693-5.988388 12.015661-3.845585 26.157753 5.520737 36.192294l255.896134 274.308483 0 309.339324c0 12.847609 7.895831 24.602328 20.389376 30.328749l189.116195 86.432535c5.154393 2.371 10.771321 3.515057 16.33913 3.515057 6.541997 0 13.090133-1.607614 18.926048-4.797259 10.718109-5.945409 17.427928-16.503882 17.809621-28.037567l12.957103-396.767536 245.078765-274.90507C859.543438 177.316451 861.425298 163.313529 855.342766 151.46262zM520.773827 804.275693l-117.384477-53.647851L403.38935 483.628836l127.858016 0L520.773827 804.275693zM550.774095 416.986019c-1.963725-0.299829-3.761674-1.090844-5.809309-1.090844L383.519814 415.895175 181.938726 199.803605l562.427506 0L550.774095 416.986019zM685.454494 524.008498l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 654.104485l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 773.618463l273.392624 0 0 59.759035-273.392624 0 0-59.759035Z" fill="#666666" p-id="7767"></path></svg></div>
                                </el-popover>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="goods_name"
                            label="产品型号"
                            width="202">
                            <template slot="header" slot-scope="scope">
                                <el-popover class="filterHeader"
                                    v-model="xhVisible"
                                    placement="bottom"
                                    trigger="click">
                                    <div class="pop-wrap">
                                        <div class="cleck-wrap">
                                            <el-input class="btn-search"
                                                placeholder="搜索"
                                                prefix-icon="el-icon-search"
                                                v-model="xinghaokeyInput"
                                                @input="xinghaochangeInput"
                                                clearable
                                                size="small">
                                            </el-input>
                                            <div class="check-box">
                                                <div class="sf scrollBox">
                                                    <el-checkbox v-if="isData" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                                    <el-checkbox-group v-model="selectedxinghaoCheckbox" @change="handleCheckedxinghaoChange">
                                                        <el-checkbox v-for="item in xinghaoCheckbox" :label="item.goods_spec_id" :key="item.goods_spec_id">{{  item.spec_name }}（ {{ item.total_num }} ）</el-checkbox>
                                                    </el-checkbox-group>
                                                </div>
                                            </div>
                                            <div class="footerWrap">
                                                <div class="btnWrap">
                                                    <el-button size="medium" @click="xhCancel" class="nl-need-cancel-btn">取消</el-button>
                                                    <el-button size="medium" @click="xhSure" class="nl-need-sure-btn">确定</el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="reference" style="cursor: pointer;">产品型号<svg t="1782501535717" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7766" width="200" height="200"><path d="M855.342766 151.46262c-6.056949-11.851932-18.984377-19.393699-33.219589-19.393699L101.903901 132.068921c-14.360056 0-27.412326 7.704472-33.396621 19.744693-5.988388 12.015661-3.845585 26.157753 5.520737 36.192294l255.896134 274.308483 0 309.339324c0 12.847609 7.895831 24.602328 20.389376 30.328749l189.116195 86.432535c5.154393 2.371 10.771321 3.515057 16.33913 3.515057 6.541997 0 13.090133-1.607614 18.926048-4.797259 10.718109-5.945409 17.427928-16.503882 17.809621-28.037567l12.957103-396.767536 245.078765-274.90507C859.543438 177.316451 861.425298 163.313529 855.342766 151.46262zM520.773827 804.275693l-117.384477-53.647851L403.38935 483.628836l127.858016 0L520.773827 804.275693zM550.774095 416.986019c-1.963725-0.299829-3.761674-1.090844-5.809309-1.090844L383.519814 415.895175 181.938726 199.803605l562.427506 0L550.774095 416.986019zM685.454494 524.008498l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 654.104485l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 773.618463l273.392624 0 0 59.759035-273.392624 0 0-59.759035Z" fill="#666666" p-id="7767"></path></svg></div>
                                </el-popover>
                            </template>
                            <template slot-scope="scope">
                                <div style="white-space: pre-line; text-align: left;">{{ scope.row.goods_name }}
                                    {{ scope.row.spec_name }}
                                </div>
                            </template>
                            </el-table-column>
                            <!-- <el-table-column
                            prop="edu"
                            label="额度/账期"
                            width="106">
                            <template slot="header" slot-scope="scope">
                                <el-popover class="filterHeader"
                                    placement="bottom"
                                    trigger="click">
                                    <div class="pop-wrap">
                                        <div class="cleck-wrap">
                                            <el-input class="btn-search"
                                                placeholder="搜索"
                                                prefix-icon="el-icon-search"
                                                v-model="edukeyInput"
                                                @change="educhangeInput"
                                                clearable
                                                size="small">
                                            </el-input>
                                            <div class="check-box">
                                                <div class="sf scrollBox">
                                                    <el-radio-group v-model="selectededuRadio" @input="eduInput">
                                                        <el-radio :label="item.id" v-for="item in eduRadio" :key="item.id">{{  item.name }}（ {{ item.num }} ）</el-radio>
                                                    </el-radio-group>
                                                </div>
                                            </div>
                                            <div class="footerWrap">
                                                <div class="btnWrap">
                                                    <el-button size="medium" class="nl-need-cancel-btn">取消</el-button>
                                                    <el-button size="medium" class="nl-need-sure-btn">确定</el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="reference" style="cursor: pointer;">额度/账期<svg t="1782501535717" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7766" width="200" height="200"><path d="M855.342766 151.46262c-6.056949-11.851932-18.984377-19.393699-33.219589-19.393699L101.903901 132.068921c-14.360056 0-27.412326 7.704472-33.396621 19.744693-5.988388 12.015661-3.845585 26.157753 5.520737 36.192294l255.896134 274.308483 0 309.339324c0 12.847609 7.895831 24.602328 20.389376 30.328749l189.116195 86.432535c5.154393 2.371 10.771321 3.515057 16.33913 3.515057 6.541997 0 13.090133-1.607614 18.926048-4.797259 10.718109-5.945409 17.427928-16.503882 17.809621-28.037567l12.957103-396.767536 245.078765-274.90507C859.543438 177.316451 861.425298 163.313529 855.342766 151.46262zM520.773827 804.275693l-117.384477-53.647851L403.38935 483.628836l127.858016 0L520.773827 804.275693zM550.774095 416.986019c-1.963725-0.299829-3.761674-1.090844-5.809309-1.090844L383.519814 415.895175 181.938726 199.803605l562.427506 0L550.774095 416.986019zM685.454494 524.008498l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 654.104485l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 773.618463l273.392624 0 0 59.759035-273.392624 0 0-59.759035Z" fill="#666666" p-id="7767"></path></svg></div>
                                </el-popover>
                            </template>
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" :content="scope.row.edutext" placement="bottom">
                                    <div class="watermark-view">
                                        <span class="companyCredit icon2"></span>{{ scope.row.edu }}
                                    </div>
                                </el-tooltip>
                            </template>
                            </el-table-column> -->
                            <el-table-column
                            prop="total_num"
                            label="数量/我要接龙"
                            width="420">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    数量/我要接龙
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="orders_price">
                                    <span>
                                        <el-tooltip class="item" effect="dark" content="含税（型号对应）" placement="top">
                                            <div>票</div>
                                        </el-tooltip>
                                    </span>
                                    <div class="vertical_center customProgress el-row el-row--flex">
                                        <div class="el-col el-col-12">
                                            <div class="scheduleCont_1_left_1 unborder" style="height: 1.25rem; border-color: rgb(235, 57, 53);">
                                                <div class="un_xg_1_3_1" :style="{width:`${Number(((scope.row.total_num - scope.row.bid_remain_count) / scope.row.total_num * 100).toFixed(0))}%`}"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <el-button size="medium" class="btnPickDragon" @click="dialogFormBtn(scope.row)">我要接龙</el-button>
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="kfpingtai"
                            label="可发平台"
                            width="140">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    可发平台
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="全部" placement="top">
                                    <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;">全部</div>
                                </el-tooltip>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="kfshengfen"
                            label="可发省份"
                            width="140">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    可发省份
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="全国" placement="top">
                                    <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;">全国</div>
                                </el-tooltip>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="city_text"
                            label="落地省份"
                            width="120">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    落地省份
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div>【{{ scope.row.city_text }}】</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="deadline"
                            label="截止时间"
                            width="220">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    截止时间
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="border-time">截止{{ scope.row.deadline }}</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="shouhuodi"
                            label="收货地"
                            width="122">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    收货地
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <el-tooltip placement="top">
                                    <div slot="content" style="white-space: pre-line;">
                                        <div v-for="item in wucang" :key="item.id">{{ item.warehouse_name }}</div>
                                    </div>
                                    <div style="white-space: pre-line;">新愿景<br/>附近{{ wucang.length }}仓可选</div>
                                </el-tooltip>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="arrive_type"
                            label="到货时效"
                            width="140">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    到货时效
                                </div>
                            </template>
                            <!-- <template slot="header" slot-scope="scope">
                                <el-popover class="filterHeader"
                                    placement="bottom"
                                    trigger="click">
                                    <div class="pop-wrap">
                                        <div class="cleck-wrap">
                                            <el-input class="btn-search"
                                                placeholder="搜索"
                                                prefix-icon="el-icon-search"
                                                v-model="shixiaokeyInput"
                                                @change="shixiaochangeInput"
                                                clearable
                                                size="small">
                                            </el-input>
                                            <div class="check-box">
                                                <div class="sf scrollBox">
                                                    <el-radio-group v-model="selectedshixiaoRadio" @input="shixiaoInput">
                                                        <el-radio :label="item.id" v-for="item in shixiaoRadio" :key="item.id">{{  item.name }}</el-radio>
                                                    </el-radio-group>
                                                </div>
                                            </div>
                                            <div class="footerWrap">
                                                <div class="btnWrap">
                                                    <el-button size="medium" class="nl-need-cancel-btn">取消</el-button>
                                                    <el-button size="medium" class="nl-need-sure-btn">确定</el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div slot="reference" style="cursor: pointer;">到货时效<svg t="1782501535717" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7766" width="200" height="200"><path d="M855.342766 151.46262c-6.056949-11.851932-18.984377-19.393699-33.219589-19.393699L101.903901 132.068921c-14.360056 0-27.412326 7.704472-33.396621 19.744693-5.988388 12.015661-3.845585 26.157753 5.520737 36.192294l255.896134 274.308483 0 309.339324c0 12.847609 7.895831 24.602328 20.389376 30.328749l189.116195 86.432535c5.154393 2.371 10.771321 3.515057 16.33913 3.515057 6.541997 0 13.090133-1.607614 18.926048-4.797259 10.718109-5.945409 17.427928-16.503882 17.809621-28.037567l12.957103-396.767536 245.078765-274.90507C859.543438 177.316451 861.425298 163.313529 855.342766 151.46262zM520.773827 804.275693l-117.384477-53.647851L403.38935 483.628836l127.858016 0L520.773827 804.275693zM550.774095 416.986019c-1.963725-0.299829-3.761674-1.090844-5.809309-1.090844L383.519814 415.895175 181.938726 199.803605l562.427506 0L550.774095 416.986019zM685.454494 524.008498l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 654.104485l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 773.618463l273.392624 0 0 59.759035-273.392624 0 0-59.759035Z" fill="#666666" p-id="7767"></path></svg></div>
                                </el-popover>
                            </template> -->
                            <template slot-scope="scope">
                                <div class="limitTime limit0">{{ scope.row.arrive_type }}</div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="last_warehouse_time"
                            label="最晚入仓时间"
                            width="180">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    最晚入仓时间
                                </div>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="quality_require"
                            label="质量要求"
                            width="220">
                            <template slot="header" slot-scope="scope">
                                <div class="filterHeader">
                                    质量要求
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div style="white-space: pre-line; text-align: left;">{{ scope.row.quality_require }}</div>
                            </template>
                            </el-table-column>
                        </el-table>
                        <div class="pageWrap">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page.sync="page"
                                :page-sizes="0"
                                :page-size="limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <myleft></myleft>
            <div class="right">
                <div class="top flex">
                    <div class="btn flex">
                        <el-button type="primary" icon="el-icon-plus" size="small">
                            <router-link to="/addCailiao">新增</router-link>
                        </el-button>
                        <el-button type="danger" icon="el-icon-delete" size="small" @click="deleteSelect">删除选中项</el-button>
                    </div>
                    <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline flex">
                        <el-form-item prop="entrust_id">
                            <el-input v-model="formInline.entrust_id" placeholder="委托单位id"></el-input>
                        </el-form-item>
                        <el-form-item prop="serial">
                            <el-input v-model="formInline.serial" placeholder="委托编号"></el-input>
                        </el-form-item>
                        <el-form-item prop="date">
                            <el-date-picker v-model="formInline.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="changeDate">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="entrust_phone">
                            <el-input v-model="formInline.entrust_phone" placeholder="姓名"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('formInline')">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- v-loading.fullscreen.lock="loading" -->
                <!-- <div class="bot">
                    <el-table
                        ref="singleTable"
                         element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData"
                        border
                        stripe
                        style="width: 100%"
                        max-height="95%"
                        :default-sort = "{prop: 'id', order: 'descending'}"
                        @selection-change="handleSelectionChange">
                        <el-table-column
                        type="selection"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        fixed
                        prop="id"
                        label="ID"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        prop="entrust_id"
                        label="委托单位"
                        width="270">
                            <template slot-scope="scope">
                                <div v-for="item in danweiList" :key="item.id">
                                    <div v-if="scope.row.entrust_id == item.id">{{ item.name }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="serial"
                        label="委托编号"
                        width="270">
                        </el-table-column>
                        <el-table-column
                        prop="entrust_phone"
                        label="委托人"
                        width="200">
                        </el-table-column>
                        <el-table-column
                        prop="entrust_time"
                        :formatter="dateFormat"
                        label="委托日期"
                        width="200">
                        </el-table-column>
                        <el-table-column
                        prop="status"
                        label="状态"
                        width="200">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.status == 'notcreate'" @click="handleSee(scope.row.id)" type="primary" size="small" class="wstatus">生成任务检测单</el-button>
                                <el-button v-if="scope.row.status == 'create'" @click="handleSee(scope.row.id)" type="text" size="small" class="ystatus">已生成任务检测单</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="150">
                        <template slot-scope="scope">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="page"
                            :page-size="per_page"
                            layout="total, prev, pager, next, jumper"
                            :total="total"
                            :pager-count="5">
                        </el-pagination>
                    </div>
                </div>
            </div> -->
        </div>
        <!-- 我要接龙弹出层 -->
        <div class="jldialog">
            <el-dialog title="新愿景" :visible="dialogFormVisible" :destroy-on-close="true" @open="wucangOpen" @close="wucangClose" width="836px" top="0">
                <div class="name">{{ tchuang.goods_name }}-{{ tchuang.spec_name}}</div>
                <div class="list flex">
                    <div>采购类型：群接龙</div>
                    <!-- <div>串码要求：未激活/未绑定锁/非定制机/非租赁机/非国补</div>
                    <div>税票要求：含税（型号对应）</div>
                    <div>包装要求：原装/原封</div> -->
                    <div>到货时效：{{ tchuang.arrive_type }}</div>
                    <!-- <div>串码选项：不需要提供串码</div> -->
                    <div>可发平台：全部</div>
                    <div>可发省份：全国</div>
                    <!-- <div class="last">账期要求：T+0（16:30前入仓T+0工作日付款，16:30后入仓T+0工作日后次日付款）</div> -->
                </div>
                <!-- <div class="xx">
                    <p>注意事项：</p>
                    <p>1、一笔订单可多次出价竞拍：</p>
                    <p>2、成交后，请根据送货时间要求按时送货至所选仓库：</p>
                    <p>3、出价后，暂时将按照订单内台数X30元冻结您的履约保证金，上限为10000，成交数量全部入仓后，将全部退还本次冻结的保证金，未全部履约入仓，将根据未入仓履约台数X30元扣除履约保证金：</p>
                    <p>4、当前订单的最晚入仓时间为2026-06-1923：59：59，请您及时发货，若非平台原因订单内最后一台的入仓时间晚于最晚复入仓时间，则按照未入仓台数×30元扣除顾约保证金，若冻结金额达到冻结上限时！系统将根据您的未入仓台数扣除顾约附近58仓可选保证金！扣罚金额=上限金额÷总订单台数×您未入仓台数
                    </p>
                </div> -->
                <div class="canyu">
                    <div class="tt flex">
                        <img src="" alt="">
                        <p>群接龙</p>
                    </div>
                    <span class="line">
                        <div class="progress" :style="{width:`${Number(((tchuang.total_num - tchuang.bid_remain_count) / tchuang.total_num * 100).toFixed(0))}%`}"></div>
                    </span>
                    <div class="">1台也可参与，成交后请按到货时效，送至指定仓库；16：30前入仓T+0工作日付款，16：30后入仓T+0工作日后次日付简款</div>
                </div>
                <div class="chujia">
                    <div v-if="baojia.length>0" class="cons">
                        <ul class="biddingInfo">
                            <li v-for="item in baojia" :key="item.id">
                                <!-- 1别人 0他人 隐藏****** -->
                                <div v-if="item.is_self == 1" class="company">{{ item.company_name }}</div>
                                <div v-if="item.is_self == 0" class="company">{{ formatItem(item.company_name) }}</div>
                                <div v-if="item.is_self == 1" class="price">出价： <span>￥{{ item.price }} </span></div>
                                <div v-if="item.is_self == 0" class="price">出价： <span>￥{{ formatItemNum(item.price) }} </span></div>
                                <div v-if="item.is_self == 1" class="quantity">数量：{{ item.num }}台 </div>
                                <div v-if="item.is_self == 0" class="quantity">数量：{{ formatItemNum(item.num) }}台 </div>
                                <div class="status"><div style="color: rgb(4, 217, 25);">{{ item.status_text }}</div></div>
                            </li>
                        </ul>
                    </div>
                    <p class="zanwu" v-else>暂无出价</p>
                </div>
                <div class="bd flex">
                    <div class="input">
                        <div class="top flex">
                            <li class="flex">
                                <p>您的出价：</p>
                                <el-input v-model="price" @input="changePrice" autocomplete="off" placeholder="请输入您的出价"></el-input>
                            </li>
                            <li class="flex">
                                <p>数量：</p>
                                <el-input v-model="num" @input="changeNum" autocomplete="off" placeholder="请输入"></el-input>
                            </li>
                        </div>
                        <div class="bot">
                            <li class="flex">
                                <p>选择无仓：</p>
                                <el-select v-model="values" @change="valusChange($event)" placeholder="请选择">
                                    <el-option v-for="item in wucang" :key="item.id" :label="item.warehouse_name" :value="item.id">
                                    </el-option>
                                </el-select>
                            </li>
                        </div>
                    </div>
                    <button @click="tjchujia" type="primary">确定出价</button>
                    <div class="warehouseAdd" style="left: 70px;">{{ wucangAddress }}</div>
                </div>
            </el-dialog>
        </div>
    </div>
  </template>

  <script>
    import { getGrabBrand, getBrandGoods, getTaskList, getWarehouseList, getTaskAllQuote, submitQuote, getCurrentCate, getCurrentBrandSpec, getCurrentCity } from "@/api";
    import myheader from "@/components/common/header";
    import myleft from "@/components/common/left";
      export default {
          data () {
              return {
                // 品类全部
                currentIndexQ: true,
                // 品牌选择
                currentIndex: 0, // 当前选中项的索引
                pinpai: [],
                pinpaiId: '', // 选择的品牌id
                // firstId: '', // 品牌第一个数据id
                canScrollLeft: true,
                canScrollRight: true, // 初始状态，根据实际情况调整
                // 品类选择
                currentIndexP: '', // 当前选中项的索引
                pinlei: [],
                pinleiId: '',
                lbVisible: false, // 品类弹窗是否可见
                canScrollLeftPl: true,
                canScrollRightPl: true, // 初始状态，根据实际情况调整
                // 落地省份
                selectedRadio: "全部需求",
                sfId: '',
                sfRadio: [],
                // 接龙数据
                tableData: [],
                // 数据列表
                loading: false,
                total: 0,
                limit: 7, //每页多少数据
                page: 1, // 当前页码
                // 类别搜索框
                leibiekeyInput: '',
                // 类别选项
                selectedleibieRadio: '',
                leibieId: '',
                leibieRadio: [],
                filteredOptions: [], // 用于存储过滤后的选项
                // 型号搜索框
                xinghaokeyInput: '',
                // 型号选项
                checkAll: false,
                isIndeterminate: false,
                selectedxinghaoCheckbox: [],
                xinghaoId: '',
                xinghaoCheckbox: [],
                filteredOptionsX: [], // 用于存储过滤后的选项
                isData: true, // 搜索是否有数据
                xhVisible: false, // 型号弹窗是否可见
                // 额度搜索框
                edukeyInput: '',
                // 额度选项
                selectededuRadio: '',
                eduRadio: [
                    {
                        id: 1,
                        name: 'T+2',
                        num: '4'
                    }
                ],
                // 时效搜索框
                shixiaokeyInput: '',
                // 时效选项
                selectedshixiaoRadio: '',
                shixiaoRadio: [
                    {
                        id: 1,
                        name: '当日 24:00'
                    },
                    {
                        id: 2,
                        name: '次日 24:00'
                    },
                    {
                        id: 3,
                        name: '后日 24:00'
                    },
                    {
                        id: 4,
                        name: '3日后到货'
                    },
                    {
                        id: 5,
                        name: '已过到货时效'
                    }
                ],

                dialogFormVisible: false, // 我要接龙弹窗
                form: {},
                baojia: [], // 报价数据
                renwuId: '', // 任务id
                // 我要接龙选择无仓
                price: '',
                num: '',
                warehouse_id: '',
                wucang: [],
                wucangAddress: '', // 仓库地址
                values: '', // 
                // 弹窗数据
                tchuang: {
                    goods_name: ''
                },

                // 委托单位列表
                danweiList: [],
                // 筛选
                start_time: '', // 开始日期
                end_time: '', // 结束日期
                formInline: {
                    entrust_id: '',
                    serial: '',
                    date: '',
                    entrust_phone: ''
                },
                rules: {
                    entrust_id: [
                        { required: false, message: '请输入委托单位id', trigger: 'blur' }
                    ],
                    serial: [
                        { required: false, message: '请输入委托编号', trigger: 'blur' }
                    ],
                    date: [
                        { required: false, message: '请选择委托日期', trigger: 'change' }
                    ],
                    entrust_phone: [
                        { required: false, message: '请输入姓名', trigger: 'blur' }
                    ]
                }
              }
            },
            components: {
                myheader: myheader,
                myleft: myleft
            },
            watch: {
                // 类别 搜索
                leibiekeyInput(newVal) {
                    this.leibieRadio = this.filteredOptions.filter(item => {
                        return item.cate_name.toLowerCase().includes(newVal.toLowerCase());
                    });
                },
                // 型号 搜索
                xinghaokeyInput(newVal) {
                    this.xinghaoCheckbox = this.filteredOptionsX.filter(item => {
                        return item.spec_name.toLowerCase().includes(newVal.toLowerCase());
                    });
                    if(this.xinghaoCheckbox.length == 0){
                        this.isData = false
                    }else{
                        this.isData = true
                    }
                    console.log(this.xinghaoCheckbox)
                },
            },
            methods: {
                // 出价记录
                chujiabtn(){
                    this.$router.replace("/chujia")
                },

                // 抢单任务列表
                getTaskList(pinpaiId,pinleiId,leibieId,xinghaoId,sfId){
                    this.loading = true;
                    getTaskList({
                        brand_id: pinpaiId, // 品牌id
                        cate_id: leibieId, // 品类id
                        goods_id: pinleiId, // 产品id
                        goods_spec_ids: xinghaoId, // 产品型号
                        city: sfId, // 落地省份id
                        page: this.page, // 当前页
                        limit: this.limit // 每页条数
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.list;
                            this.total = res.data.data.total
                            // this.shouhuodi = '哈哈'
                        }
                    });
                },

                // 品牌选择
                toggleColor(index, id) {
                    this.currentIndex = index;
                    this.pinpaiId = id;
                    this.page = 1;
                    getBrandGoods({
                        brand_id: id // 品牌id
                    }).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.pinlei = res.data.data;
                            this.pinleiId = res.data.data[0].goods_id; // 获取第一个数据id
                            this.getBrandGoods(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取商品
                            this.getCurrentCate(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取品类
                            this.getCurrentBrandSpec(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取型号
                            this.getCurrentCity(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取地区
                            this.getTaskList(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 任务列表
                        }
                    })
                    // this.getBrandGoods(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取商品
                    // this.getCurrentCate(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取品类
                    // this.getCurrentBrandSpec(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取型号
                    // this.getCurrentCity(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取地区
                    // this.getTaskList(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 任务列表
                    // console.log(id);
                },
                handleScroll() {
                    const scrollList = this.$refs.wrapperCon;
                    this.canScrollLeft = scrollList.scrollLeft > 0; // 如果已经滚动，则显示向左按钮
                    this.canScrollRight = scrollList.scrollLeft < scrollList.scrollWidth - scrollList.clientWidth; // 如果未滚动到最右，则显示向右按钮
                },
                scroll(direction) {
                    const scrollList = this.$refs.wrapperCon;
                    if (direction === -1 && scrollList.scrollLeft > 0) { // 向左滚动
                        // 保存滚动盒子左侧已滚动的距离
                        let left = this.$refs.wrapperCon.scrollLeft
                        let num = 0
                        clearInterval(this.timer)
                        this.timer = null
                        this.timer = setInterval(() => {
                            //   !left:已经滚动到最左侧
                            //   一次性滚动距离（可调节）
                            if (!left || num >= 100) {
                                // 停止滚动
                                clearInterval(this.timer)
                                this.timer = null
                                return
                            }
                            // 给滚动盒子元素赋值向左滚动距离
                            this.$refs.wrapperCon.scrollLeft = left -= 30
                            // 保存向左滚动距离（方便判断一次性滚动多少距离）
                            num += 30
                        }, 50)
                    } else if (direction === 1 && scrollList.scrollLeft < scrollList.scrollWidth - scrollList.clientWidth) { // 向右滚动
                        // 保存滚动盒子左侧已滚动的距离
                        let left = this.$refs.wrapperCon.scrollLeft
                        // 保存元素的整体宽度
                        let scrollWidth = this.$refs.wrapperCon.scrollWidth
                        // 保存元素的可见宽度
                        let clientWidth = this.$refs.wrapperCon.clientWidth
                        let num = 0
                        clearInterval(this.timer)
                        this.timer = setInterval(() => {
                        // 已经滚动距离+可见宽度
                        // left+clientWidth>=scrollWidth：滚动到最右侧
                            // num>=100一次性滚动距离
                            if (left + clientWidth >= scrollWidth || num >= 100) {
                                clearInterval(this.timer)
                                return
                            }
                            // 给滚动盒子元素赋值向左滚动距离
                            this.$refs.wrapperCon.scrollLeft = left += 30
                            // 保存向左滚动距离（方便判断一次性滚动多少距离）
                            num += 30
                        }, 50)
                        // 20：速度（可调节）
                    }
                    this.handleScroll(); // 更新按钮状态
                },

                // 产品全部选择
                toggleColorQ(){
                    this.currentIndexQ = true; // 取消全部选择
                    this.currentIndexP = '';
                    this.pinleiId = ''; // 品类商品id设置为空，因为选择其他商品会重置id
                    this.getTaskList(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 任务列表
                },

                // 产品选择
                toggleColorP(index, id) {
                    this.currentIndexQ = false; // 取消全部选择
                    this.currentIndexP = index;
                    this.pinleiId = id;
                    this.page = 1;
                    this.getTaskList(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 任务列表
                    this.getCurrentCate(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取品类
                    this.getCurrentBrandSpec(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取型号
                    // console.log(id);
                },
                getBrandGoods(pinpaiId,pinleiId,leibieId,xinghaoId,sfId){
                    getBrandGoods({
                        brand_id: pinpaiId // 品牌id
                    }).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.pinlei = res.data.data;
                            // this.pinleiId = res.data.data[0].goods_id; // 获取第一个品牌商品id
                            // this.getTaskList(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 任务列表 默认获取第一个品牌 在获取第一个品牌商品 去获取抢单任务列表
                        }
                    });
                },
                handlePlScroll() {
                    const scrollList = this.$refs.wrapperConPl;
                    this.canScrollLeftPl = scrollList.scrollLeft > 0; // 如果已经滚动，则显示向左按钮
                    this.canScrollRightPl = scrollList.scrollLeft < scrollList.scrollWidth - scrollList.clientWidth; // 如果未滚动到最右，则显示向右按钮
                },
                scrollPl(direction) {
                    const scrollList = this.$refs.wrapperConPl;
                    if (direction === -1 && scrollList.scrollLeft > 0) { // 向左滚动
                        // 保存滚动盒子左侧已滚动的距离
                        let left = this.$refs.wrapperConPl.scrollLeft
                        let num = 0
                        clearInterval(this.timer)
                        this.timer = null
                        this.timer = setInterval(() => {
                            //   !left:已经滚动到最左侧
                            //   一次性滚动距离（可调节）
                            if (!left || num >= 100) {
                                // 停止滚动
                                clearInterval(this.timer)
                                this.timer = null
                                return
                            }
                            // 给滚动盒子元素赋值向左滚动距离
                            this.$refs.wrapperConPl.scrollLeft = left -= 30
                            // 保存向左滚动距离（方便判断一次性滚动多少距离）
                            num += 30
                        }, 50)
                    } else if (direction === 1 && scrollList.scrollLeft < scrollList.scrollWidth - scrollList.clientWidth) { // 向右滚动
                        // 保存滚动盒子左侧已滚动的距离
                        let left = this.$refs.wrapperConPl.scrollLeft
                        // 保存元素的整体宽度
                        let scrollWidth = this.$refs.wrapperConPl.scrollWidth
                        // 保存元素的可见宽度
                        let clientWidth = this.$refs.wrapperConPl.clientWidth
                        let num = 0
                        clearInterval(this.timer)
                        this.timer = setInterval(() => {
                        // 已经滚动距离+可见宽度
                        // left+clientWidth>=scrollWidth：滚动到最右侧
                            // num>=100一次性滚动距离
                            if (left + clientWidth >= scrollWidth || num >= 100) {
                                clearInterval(this.timer)
                                return
                            }
                            // 给滚动盒子元素赋值向左滚动距离
                            this.$refs.wrapperConPl.scrollLeft = left += 30
                            // 保存向左滚动距离（方便判断一次性滚动多少距离）
                            num += 30
                        }, 50)
                        // 20：速度（可调节）
                    }
                    this.handlePlScroll(); // 更新按钮状态
                },

                // 落地省份选择城市
                sfInput(){
                    const selectedItem = this.sfRadio.find(item => item.id === this.selectedRadio); // 获取选中项的详细信息
                    console.log("id=" + this.selectedRadio);
                    if(this.selectedRadio == '全部需求'){
                        this.sfId = ''
                    }else{
                        this.sfId = this.selectedRadio;
                    }
                    this.page = 1;
                    this.getTaskList(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 任务列表
                    console.log("文字：", selectedItem) // 获取选中项的详细信息，例如 name 和 id
                },

                // 落地省份筛选去重
                getCurrentCity(pinpaiId,pinleiId,leibieId,xinghaoId,sfId){
                    getCurrentCity({
                        brand_id: pinpaiId, // 品牌id
                        cate_id: leibieId, // 品类id
                        goods_id: pinleiId, // 产品id
                        goods_spec_ids: xinghaoId, // 产品型号
                        city: sfId // 落地省份id
                    }).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.sfRadio = res.data.data;
                            // 落地省份有全国删除
                            let id1 = this.sfRadio.findIndex(item => {
                                if (item.city_name == '全国') {
                                    return true
                                }
                            })
                            this.sfRadio.splice(id1, 1)
                        }
                    });
                },

                // 类别搜索
                // leibiechangeInput(val){
                //     this.leibiekeyInput = val
                //     // console.log(val)
                // },

                // 类别筛选
                leibieInput(){
                    const selectedleibieItem = this.leibieRadio.find(item => item.cate_id === this.selectedleibieRadio); // 获取选中项的详细信息
                    this.leibieId = this.selectedleibieRadio;
                    console.log("id=" + this.selectedleibieRadio)
                    console.log("文字：", selectedleibieItem) // 获取选中项的详细信息，例如 name 和 id
                },

                // 品类筛选去重
                getCurrentCate(pinpaiId,pinleiId,leibieId,xinghaoId,sfId){
                    getCurrentCate({
                        brand_id: pinpaiId, // 品牌id
                        cate_id: leibieId, // 品类id
                        goods_id: pinleiId, // 产品id
                        goods_spec_ids: xinghaoId, // 产品型号
                        city: sfId // 落地省份id
                    }).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.leibieRadio = res.data.data;
                            this.filteredOptions = res.data.data
                        }
                    });
                },

                // 类别 取消
                lbCancel(){
                    this.lbVisible = false;
                    this.selectedleibieRadio = '';
                    this.leibieId = '';
                    this.leibiekeyInput = ''
                    // console.log('哈哈')
                },

                // 类别 确定
                lbSure(){
                    this.lbVisible = false;
                    this.page = 1;
                    this.getTaskList(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 任务列表
                    this.leibiekeyInput = ''
                    // console.log(this.pinleiId)
                    // console.log('哈哈')
                },

                // 额度筛选
                eduInput(){
                    const selectededuItem = this.eduRadio.find(item => item.id === this.selectededuRadio); // 获取选中项的详细信息
                    console.log("id=" + this.selectededuRadio)
                    console.log("文字：", selectededuItem) // 获取选中项的详细信息，例如 name 和 id
                },

                // 型号筛选 全选
                handleCheckAllChange(val) {
                    if (val) {
                        // this.selectedxinghaoCheckbox = this.xinghaoCheckbox.map(item => item.id); // 选中所有项的 ID
                        this.selectedxinghaoCheckbox = val; // 选中所有项的 ID
                        this.selectedxinghaoCheckbox = this.xinghaoCheckbox.map(item => item.goods_spec_id); // 选中所有项的 ID
                        this.isIndeterminate = false;
                        this.xinghaoId = this.selectedxinghaoCheckbox.join(',');
                        console.log(this.selectedxinghaoCheckbox)
                    } else {
                        this.selectedxinghaoCheckbox = []; // 清除所有选中项
                        this.xinghaoId = ''
                    }
                },
                // 多选
                handleCheckedxinghaoChange(value) {
                    // 处理选中项变化的情况，例如更新全选状态等。
                    let checkedCount = value.length;
                    this.checkAll = checkedCount === this.xinghaoCheckbox.length; // 根据选中项更新全选状态
                    this.isIndeterminate = checkedCount > 0 && checkedCount < this.xinghaoCheckbox.length;
                    console.log(JSON.stringify(this.selectedxinghaoCheckbox)) // 输出[1, 2]
                    console.log(this.selectedxinghaoCheckbox.join(',')) // 输出1, 2
                    this.xinghaoId = this.selectedxinghaoCheckbox.join(',');
                },

                // 型号筛选去重
                getCurrentBrandSpec(pinpaiId,pinleiId,leibieId,xinghaoId,sfId){
                    getCurrentBrandSpec({
                        brand_id: pinpaiId, // 品牌id
                        cate_id: leibieId, // 品类id
                        goods_id: pinleiId, // 产品id
                        goods_spec_ids: xinghaoId, // 产品型号
                        city: sfId // 落地省份id
                    }).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.xinghaoCheckbox = res.data.data;
                            this.filteredOptionsX = res.data.data
                        }
                    });
                },

                // 型号 取消
                xhCancel(){
                    this.xhVisible = false;
                    this.selectedxinghaoCheckbox = [];
                    this.checkAll = false;
                    this.xinghaoId = '';
                    this.xinghaokeyInput = ''
                    // console.log('哈哈')
                },

                // 型号 确定
                xhSure(){
                    this.xhVisible = false;
                    this.page = 1;
                    this.getTaskList(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 任务列表
                    this.xinghaokeyInput = ''
                    // console.log(this.xinghaoId)
                    // console.log('哈哈')
                },

                // 品牌获取
                getGrabBrand() {
                    getGrabBrand({}).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.pinpai = res.data.data;
                            this.pinpaiId = res.data.data[0].id; // 获取第一个数据id
                            this.getTaskList(res.data.data[0].id); // 默认第一个品牌获取抢单任务列表
                            this.getBrandGoods(res.data.data[0].id); // 获取商品
                            this.getCurrentCate(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取品类
                            this.getCurrentBrandSpec(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取型号
                            this.getCurrentCity(this.pinpaiId,this.pinleiId,this.leibieId,this.xinghaoId,this.sfId); // 获取地区
                        }
                    });
                },

                // 我要接龙
                dialogFormBtn(row){
                    console.log(row);
                    this.tchuang = row; // 弹窗数据赋值
                    this.renwuId = row.id; // 任务id
                    this.dialogFormVisible = true // 打开弹窗
                },

                // 全部报价
                getTaskAllQuote(){
                    getTaskAllQuote({
                        taskgrab_id: this.renwuId
                    }).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.baojia = res.data.data
                        }
                    });
                },

                // 他人报价隐藏***方法 中文保留后两个字 其余为*
                formatItem(item) {
                   return item.slice(0, -2).replace(/./g, '*') + item.slice(-2);
                },
                // 数字 几个字符几个*
                formatItemNum(item) {
                   return item.replace(/./g, '*');
                },

                // 填写出价
                changePrice(val){
                    this.price = val
                    // console.log(val)
                },

                // 填写数量
                changeNum(val){
                    this.num = val
                    // console.log(val)
                },

                // 仓库下拉
                getWarehouseList(){
                    getWarehouseList({}).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.wucang = res.data.data
                        }
                    });
                },

                // 接龙弹窗打开事件
                wucangOpen(){
                    this.getWarehouseList(); // 弹窗显示调用仓库
                    this.getTaskAllQuote(); // 弹窗显示全部报价
                },
                
                // 接龙弹窗关闭事件
                wucangClose(){
                    this.dialogFormVisible = false;
                    this.price = '';
                    this.num = '';
                    // this.wucang = [];
                    this.values = '';
                    this.wucangAddress = '',
                    this.warehouse_id = '';
                    this.baojia = []
                },

                // 仓库下拉选择事件
                valusChange(val){
                    // console.log(val)
                    this.warehouse_id = val
                    this.wucang.forEach((item) => {
                        if (val === item.id) {
                            this.wucangAddress = item.address; // 地址
                        }
                    });
                },

                // 提交出价
                tjchujia(){
                    submitQuote({
                        taskgrab_id: this.renwuId, // 接龙任务id
                        price: this.price, // 出价
                        num: this.num, // 供货数量
                        warehouse_id: this.warehouse_id // 仓库id
                    }).then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.dialogFormVisible = false;
                            this.price = '';
                            this.num = '';
                            // this.wucang = [];
                            this.values = '';
                            this.wucangAddress = '',
                            this.warehouse_id = '';
                            this.baojia = [];
                            this.$message({
                                type: 'success',
                                message: '提交出价成功'
                            });
                            this.$router.replace("/chujia")
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    });
                },


                // 日期范围回显
                changeDate(e) {
                    console.log(e[0], e[1]);
                    this.start_time = e[0]; // 开始日期
                    this.end_time = e[1]; // 结束日期
                },
                // 列表
                contractEntrustIndex() {
                    this.loading = true;
                    contract_entrust_index({
                        params: {
                            type: 'material'
                        }
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                            this.total = res.data.data.total // 数据总条数
                        }
                    });
                },
                // 委托单位列表
                basisEntrustIndex() {
                    this.loading = true;
                    basis_entrust_index().then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.danweiList = res.data.data.data;
                        }
                    });
                },
                // 删除选中项
                deleteSelect() {
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                            
                        var val = this.multipleSelection;
                        var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串

                        contract_entrust_del({
                            ids: multipleSelection
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.contractEntrustIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });

                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 筛选
                submitForm(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.formInline.name);
                            this.loading = true;
                            contract_entrust_index({
                                params: {
                                    type: 'material',
                                    entrust_id: this.formInline.entrust_id,
                                    serial: this.formInline.serial,
                                    entrust_phone: this.formInline.entrust_phone,
                                    start_time: this.start_time,
                                    end_time: this.end_time,
                                    page: this.page
                                }
                            }).then((res) => {
                                // console.log(res.data.data);
                                this.loading = false;
                                if (res.data.code == 1) {
                                    this.tableData = res.data.data.data;
                                    this.total = res.data.data.total // 数据总条数
                                }
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 当选择项发生变化时会触发该事件
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                    // var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串
                    // console.log(multipleSelection)
                },
                // 行数据查看跳转任务单
                handleSee(row) {
                    console.log(row);
                },
                // 行数据查看
                handleClick(row) {
                    console.log(row);
                },
                // 行数据编辑
                handleEdit(row) {
                    console.log(row);
                },
                // 行数据删除
                handleDelete(row) {
                    // console.log(row.id);
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {

                        contract_entrust_del({
                            ids: row.id
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.contractEntrustIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                        
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                handleCurrentChange(page) {
                    // console.log(`当前页: ${page}`);
                    this.loading = true;
                    getTaskList({
                        page: page,
                        limit: this.limit
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.list;
                        }
                    });
                },
                // 时间戳转日期格式
                dateFormat(row) {
                    // console.log(row.entrust_time*1000)
                    let data = row.entrust_time * 1000
                    let dtime = new Date(data)
                    const year = dtime.getFullYear()
                    let month = dtime.getMonth() + 1
                    if (month < 10) {
                        month = '0' + month
                    }
                    let day = dtime.getDate()
                    if (day < 10) {
                        day = '0' + day
                    }
                    let hour = dtime.getHours()
                    if (hour < 10) {
                        hour = '0' + hour
                    }
                    let minute = dtime.getMinutes()
                    if (minute < 10) {
                        minute = '0' + minute
                    }
                    let second = dtime.getSeconds()
                    if (second < 10) {
                        second = '0' + second
                    }
                    return year+ '-' + month+ '-' + day + ' ' + hour + ':' + minute + ':' + second
                }
            },
            created() {
                this.getGrabBrand(); // 获取抢单品牌
                this.getWarehouseList(); // 获取仓库地址

                // this.contractEntrustIndex(); // 列表
                // this.basisEntrustIndex() // 委托单位列表
            },
            mounted() {
                this.handleScroll(); // 组件挂载后立即检查一次滚动状态 品牌
                this.handleScrollPl(); // 组件挂载后立即检查一次滚动状态 品牌下商品
            },
            // 解决表格fixed错位问题
            updated() {
                if (this.$refs.singleTable && this.$refs.singleTable.doLayout) {
                    this.$refs.singleTable.doLayout()
                }
            }
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
      .ystatus{
        width: 100%;
        text-align: center;
        color: #847f7f;
        cursor: default;
      }
      .wstatus{
        width: 100%;
      }
      .mains{
          border-radius: 5px;
      }
      .lanmu{
            /* width: 100%; */
            background: rgba(255, 255, 255, .8);
            border-radius: 10px;
            padding: 0 10px 5px 40px;
            margin-bottom: 16px;
      }
      .lanmu .top{
            display: inline-block;
            background: #fff6f6;
            width: 100px;
            text-align: center;
            line-height: 30px;
            border-bottom: 2px solid #eb3935;
            color: #000;
      }
      .sub{
          margin-top: 4px;
          gap: 12px;
          min-height: 28px;
      }
      .sub p{
          width: 160px;
          color: #7d7d7d;
          flex: 0 0 auto;
      }
      .caidan{
          flex: 1;
          display: flex;
            align-items: center;
            width: calc(100% - 200px);
          /* margin-left: 20px;
          width: calc(100% - 135px); */
      }
      .caidan .left-icon{
          margin-right: 10px;
          padding: 7px;
        /* flex: 1; */
      }
      .caidan .right-icon{
          margin-left: 10px;
          padding: 7px;
      }
      .caidan .cons{
          overflow-x: auto;
            width: calc(100% - 50px);
            display: flex;
            white-space: nowrap;
            scrollbar-width: none;
            -ms-overflow-style: none;
            width: 100%;
      }
      .caidan .cons li{
            line-height: 22px;
            padding: 3px 16px;
            border-radius: 6px;
            margin-right: 20px;
            cursor: pointer;
            color: #000;
            font-size: 14px;
      }
      .caidan .cons li:last-child{
          margin-right: 0;
      }
      .caidan .cons li.active{
          background: #eb3935;
          color: #fff;
      }
      .content{
          height: calc(100% - 95px);
        align-items: flex-start;
        gap: 12px;
      }
      .xuanx{
          width: 200px;
        background: #fff;
        height: 100%;
        border-radius: 10px;
        flex: 0 0 auto;
      }
      .xuanx .luodi{
          padding-bottom: 7px;
          margin: 0 24px;
            padding: 20px 0 10px;
            font-size: 14px;
            color: #666;
          border-bottom: 1px solid #e7e7e7;
      }
      .xuanx .luodi img{
          margin-right: 8px;
      }
      .sf .el-radio-group{
          width: 100%;
          padding: 10px 0;
      }
      .contents{
          /* margin-left: 20px;
        width: calc(100% - 155px); */
        height: 100%;
        /* border-radius: 10px; */
        flex: 1;
        overflow: hidden;
      }
      .caidans{
          margin-bottom: 16px;
          border-radius: 10px;
          /* background: #fff; */
          display: flex;
          align-items: center;
      }
      .caidans .left-icon{
          margin-right: 10px;
          padding: 7px;
      }
      .caidans .right-icon{
          margin-left: 10px;
          padding: 7px;
      }
      .caidans .plei{
          width: calc(100% - 140px);
          background: #fff;
          border-radius: 10px;
          flex: 1;
          margin-right: 12px;
          display: flex;
            align-items: center;
            padding: 0 15px;
      }
      .pro{
          border-radius: 10px;
          background: #fff;
          padding: 0 15px;
          height: calc(100% - 75px);
        overflow-y: scroll;
      }
      .pro .bt{
          display: inline-flex;
          padding-bottom: 20px;
          border-bottom: 1px solid #dfe6ec;
          position: sticky;
        top: 0;
        background: #fff;
        padding-top: 15px;
      }
      .pro .bt li{
          margin-right: 10px;
        background: #f8f8f8;
        border: 1px solid #e7e7e7;
        line-height: 50px;
        width: 164px;
        text-align: center;
        border-radius: 10px;
        box-sizing: border-box;
      }
      .pro .bt li:nth-child(2),
      .bcon .list li:nth-child(2){
          width: 360px;
      }
      .pro .bt li:nth-child(3),
      .bcon .list li:nth-child(3){
          width: 180px;
      }
      .pro .bt li:nth-child(4),
      .bcon .list li:nth-child(4){
          width: 554px;
      }
      .pro .bt li:nth-child(5),
      .bcon .list li:nth-child(5){
          width: 180px;
      }
      .pro .bt li:nth-child(6),
      .bcon .list li:nth-child(6){
          width: 180px;
      }
      .pro .bt li:nth-child(7),
      .bcon .list li:nth-child(7){
          width: 200px;
      }
      .pro .bt li:nth-child(8),
      .bcon .list li:nth-child(8){
          width: 400px;
      }
      .pro .bt li:nth-child(9),
      .bcon .list li:nth-child(9){
          width: 200px;
      }
      .pro .bt li:nth-child(10),
      .bcon .list li:nth-child(10){
          width: 240px;
      }
      .pro .bt li:nth-child(11),
      .bcon .list li:nth-child(11){
          width: 320px;
      }
      .pro .bt li:nth-child(12),
      .bcon .list li:nth-child(12){
          width: 400px;
          margin-right: 0;
      }
      .bcon{
          display: inline-block;
      }
      .bcon .list{
          padding: 20px 0;
          border-bottom: 1px solid #dfe6ec;
          font-size: 14px;
      }
      .bcon .list li{
          margin-right: 10px;
          width: 164px;
          text-align: center;
      }
      .bcon .list li:nth-child(2){
          text-align: left;
        white-space: pre-line;
        line-height: 25px;
      }
      .bcon .list li.t0{
          display: flex;
          align-items: center;
          justify-content: center;
      }
      .bcon .list li.t0 span{
          width: 15px;
        height: 15px;
        background: #03cc06;
        border-radius: 50%;
        margin-right: 5px;
      }
      .bcon .jl{
          justify-content: flex-end;
      }
      .bcon .jl .btns{
          background: #df3632;
          width: 80px;
          line-height: 40px;
          color: #fff;
          border-radius: 5px;
          margin-left: 30px;
          cursor: pointer;
      }
      .bcon .jl .tiao{
          width: 120px;
        line-height: 25px;
        background: #ffdfdf;
        height: 25px;
        border-radius: 5px;
        overflow: hidden;
      }
      .bcon .jl .tiao p{
          background: #eb3935;
          height: 100%;
      }
      .bcon .date{
          border: 1px solid #eb3935;
          color: #eb3935;
        line-height: 40px;
        border-radius: 5px;
      }
      .bcon .tip p{
          white-space: pre-line;
        line-height: 25px;
      }
      .bcon .time{
          background: #eb3935;
          color: #fff;
        line-height: 32px;
        border-radius: 5px;
      }
      .bcon .list li:last-child{
          text-align: left;
          line-height: 25px;
      }
      .caidans .cons{
          padding: 10px 0;
          min-height: 28px;
            width: 100%;
            overflow-x: auto;
            white-space: nowrap;
            scrollbar-width: none;
            flex: 1;
      }
      .caidans .cons li, .caidans .quanbu{
          line-height: 20px;
        padding: 3px 12px;
        border-radius: 4px;
        margin-right: 20px;
        cursor: pointer;
        color: #666;
        font-size: 14px;
        border: 1px solid #e7e7e7;
        max-width: 280px;
        display: inline-block;
        /* overflow: hidden; */
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .caidans .cons li:last-child{
          margin-right: 0;
      }
      .caidans .cons li.active, .caidans .quanbu.active{
          background: #eb3935;
        color: #fff;
      }
      .sf .radiogroup{
          width: 100%;
      }
      .sf label{
          position: relative;
          margin: 0;
        padding: 8px 0 8px 24px;
        display: flex;
        height: 20px;
      }
      .sf label.is-checked{
          background: #fff6f6;
      }
      .sf label.is-checked:after{
          content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 6px;
        height: 100%;
        background: #eb3935;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
      .sf /deep/ .el-radio__label{
          padding-left: 12px;
          color: #7c7c7c;
          line-height: 20px;
      }
      .sf /deep/ .el-radio__inner{
          border: 1px solid #dcdfe6;
            width: 20px;
            height: 20px;
            border-radius: 2px;
      }
      .sf /deep/ .el-radio__input.is-checked .el-radio__inner{
          border-color: #eb3935;
        background-color: #eb3935;
      }
      .sf /deep/ .el-radio__inner::after{
          -webkit-box-sizing: content-box;
            box-sizing: content-box;
            content: "";
            border: 2px solid #fff;
            background: transparent;
            border-radius: 0;
            outline: none;
            border-left: 0;
            border-top: 0;
            height: 10px;
            left: 6px;
            position: absolute;
            top: 1px;
            -webkit-transform: rotate(45deg) scaleY(0);
            transform: rotate(45deg) scaleY(0);
            width: 4px;
            -webkit-transition: -webkit-transform .15s ease-in .05s;
            transition: -webkit-transform .15s ease-in .05s;
            transition: transform .15s ease-in .05s;
            transition: transform .15s ease-in .05s, -webkit-transform .15s ease-in .05s;
            -webkit-transform-origin: center;
            transform-origin: center;
      }
      .sf /deep/ .el-radio__input.is-checked .el-radio__inner::after{
          -webkit-transform: rotate(45deg) scaleY(1);
        transform: rotate(45deg) scaleY(1);
        transition: none;
      }
      .jldialog /deep/ .el-dialog{
        top: 50%;
        transform: translateY(-50%);
      }
      .jldialog /deep/ .el-dialog__title{
          /* font-weight: bold; */
      }
      .jldialog /deep/ .el-dialog__header{
          padding: 0;
          text-align: center;
          /* line-height: 80px; */
          background: #ffdd00;
          background: #5bcee1;
          color: #000;
          padding: 18px;
      }
      .jldialog .list{
          flex-wrap: wrap;
          padding: 6px 0 11px;
      }
      .jldialog .list div{
          width: 50%;
          margin-bottom: 2px;
      }
      .jldialog .list div.last{
          width: 100%;
      }
      .jldialog .name{
          padding-bottom: 11px;
        border-bottom: 1px solid #e7e7e7;
        color: #000;
        font-size: 16px;
      }
      .jldialog .xx{
          padding: 10px;
        background: #f8f8f8;
        border-radius: 5px;
      }
      .jldialog .canyu{
          padding: 10px;
          border-radius: 5px;
          margin: 10px 0;
          background: #f8f8f8;
      }
      .jldialog .canyu .line{
          height: 15px;
          display: block;
          margin: 5px 0;
          border-radius: 3px;
        background: #ffdfdf;
        position: relative;
        height: 22px;
        margin-top: 4px;    
      }
      .jldialog .canyu .line .progress {
        position: absolute;
        width: 0;
        left: 0;
        top: 0;
        bottom: 0;
        border-radius: 3px;
        background: #eb3935;
    }
      .jldialog .canyu .tt{
          text-align: center;
          color: #000;
          justify-content: center;
          align-items: center;
      }
      .jldialog .chujia{
          background: #f8f8f8;
          /* min-height: 134px; */
          border-radius: 5px;
      }
      .jldialog .chujia .cons{
          background: #f8f8f8;
        padding: 18px 12px 18px 18px;
        margin-top: 12px;
        border-radius: 4px;
        height: 156px;
      }
      .jldialog .chujia .zanwu{
          line-height: 192px;
          text-align: center;
      }
      .jldialog .bd{
          position: relative;
          margin-top: 16px;
          justify-content: space-between;
      }
      .jldialog .bd .warehouseAdd{
        position: absolute;
        left: 100px;
        bottom: -22px;
        color: #666;
        font-size: 12px;
        text-align: left;
      }
      .jldialog .bd button{
          outline: none;
          box-shadow: none;
          width: 200px;
          line-height: 40px;
          border-radius: 5px;
          text-align: center;
          background: #eb3935;
          color: #fff;
          font-size: 18px;
          border: 0;
          cursor: pointer;
      }
      .jldialog .bd .top{
          margin-bottom: 10px;
          justify-content: space-between;
      }
      .jldialog .bd .input{
          width: 452px;
      }
      .jldialog .bd /deep/ .el-input{
          flex: 1;
      }
      .jldialog .bd /deep/ .el-input__inner{
          width: 120px;
        border: 0;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        line-height: 28px;
        height: 28px;
        padding: 0 15px;
        color: #606266;
      }
      .jldialog .bd .top li:nth-child(1) /deep/ .el-input__inner{
          width: 140px;
      }
      .jldialog .bd .bot .el-select{
          flex: 1;
      }
      .jldialog .bd .bot .el-select /deep/ .el-input--suffix .el-input__inner{
          height: 36px;
          line-height: 36px;
          width: 100%;
      }
      .jldialog /deep/ .el-dialog__headerbtn .el-dialog__close{
          color: #333;
      }
      .tableWrap {
        padding: 12px;
        background: #fff;
        border-radius: 6px;
        position: relative;
        z-index: 0;
        height: calc(100% - 64px);
    }
    .cleck-wrap .btn-search{
        margin-bottom: 10px;
    }
    .cleck-wrap .check-box {
        border-radius: 3px;
        border: 1px solid #e4e7ed;
        padding: 5px 0;
        font-weight: 400;
    }
    .scrollBox{
        max-height: 220px;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .scrollBox .el-radio-group{
        padding: 0;
    }
    .scrollBox label{
        height: 26px;
        padding: 0 10px;
        align-items: center;
    }
    .scrollBox /deep/ .el-radio__inner{
        width: 14px;
        height: 14px;
        border-radius: 2px;
    }
    .scrollBox label.is-checked{
        background-color: #f5f7fa;
      }
      .scrollBox label.is-checked:after{
          display: none;
      }
      .scrollBox /deep/ .el-radio__inner::after{
          width: 3px;
          height: 8px;
          left: 4px;
          border-width: 1px;
      }
      .scrollBox /deep/ .el-radio__label{
          color: #606266;
      }
      .footerWrap{
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
      }
      .footerWrap .btnWrap .el-button{
          font-size: 14px;
          padding: 7px 21px;
      }
      .footerWrap .btnWrap .el-button:hover{
          background: #f8f8f8;
          color: #333;
          border-color: #e7e7e7;
      }
      .footerWrap /deep/ .nl-need-cancel-btn{
          background: #f8f8f8;
        border-color: #e7e7e7;
        color: #333;
      }
      .footerWrap /deep/ .nl-need-sure-btn{
          background: #eb3935;
        border-color: #eb3935;
        color: #fff;
      }
      .footerWrap .btnWrap .el-button.nl-need-sure-btn:hover{
          background: #eb3935;
        border-color: #eb3935;
        color: #fff;
      }
      .companyCredit {
        vertical-align: -.15em;
        display: inline-block;
        width: 14px;
        height: 14px;
        border-radius: 8px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        margin-right: 4px;
        background: #03cc06;
    }
    .orders_price{
        display: flex;
        align-items: center;
        justify-content: right;
    }
    .orders_price .item{
        width: 17px;
        height: 17px;
        font-size: 11px;
        border-radius: 50%;
        border: 1px solid #0e86eb;
        color: #0e86eb;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .customProgress {
        width: 180px;
        font-size: 14px;
        color: #333;
        margin-left: 6px;
    }
    .unborder {
        border: none;
        background-color: #ffdfdf;
    }
    .scheduleCont_1_left_1 .un_xg_1_3_1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        border-radius: 3px;
        background-image: -webkit-gradient(linear, left top, right top, from(#eb3935));
        background-image: linear-gradient(90deg, #eb3935);
    }
    .scheduleCont_1_left_1{
        position: relative;
        width: 100%;
        height: .8rem;
        border-radius: 3px;
        overflow: hidden;
    }
    .btnPickDragon {
        width: 68px;
        height: 30px;
        font-size: 14px;
        color: #fff;
        padding: 4px 2px;
        border-radius: 4px;
        border: 0;
        background-color: #eb3935;
    }
    .border-time{
        padding: 4px;
        border-radius: 6px;
        border: 1px solid #eb3935;
        text-align: center;
        color: #eb3935;
    }
    .limitTime {
        font-size: 14px;
        line-height: 22px;
        color: rgb(255, 255, 255);
        text-align: center;
        background-color: rgb(204, 204, 204);
        padding: 0px;
        border-radius: 4px;
        margin: 0px auto;
        background-color: rgb(235, 87, 50);
    }
    .el-table{
        color: #333;
    }
    /deep/ .el-table .cell{
        text-align: center;
    }
    /deep/ .el-table__header th.el-table__cell{
        padding: 0 0 12px;
    }
    /deep/ .el-table th.el-table__cell>.cell{
        padding-left: 4px;
        padding-right: 4px;
    }
    /deep/ .el-table th.el-table__cell>.cell .filterHeader{
        padding-left: 4px;
        padding-right: 4px;
        height: 42px;
        line-height: 42px;
        background-color: #f8f8f8;
        border-radius: 6px;
        border: 1px solid #e7e7e7;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        font-size: 14px;
        font-weight: 400;
    }
    /deep/ .el-table th.el-table__cell>.cell .filterHeader .icon{
        width: 1em;
        height: 1em;
        display: inline-block;
        vertical-align: text-bottom;
        margin-left: 4px;
    }
    /* 基础滚动条样式 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar{
        width: 8px;
        height: 8px;
    }
    /* 轨道样式 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track {
        background: #F1F1F1;
        border-radius: 10px;
    }
    /* 滑块样式 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;
    }
    /* 悬停效果 */
    .tableWrap /deep/ .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
    .scrollBox /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
        color: inherit;
    }
    .scrollBox /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .scrollBox /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #eb3935;
        border-color: #eb3935;
    }
    .biddingInfo {
        margin: 0;
        padding: 0 6px 0 0;
        max-height: 156px;
        overflow-y: auto;
    }
    /* 基础滚动条样式 */
    .biddingInfo::-webkit-scrollbar{
        width: 8px;
        height: 8px;
    }
    /* 轨道样式 */
    .biddingInfo::-webkit-scrollbar-track {
        background: #F1F1F1;
        border-radius: 10px;
    }
    /* 滑块样式 */
    .biddingInfo::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 10px;
    }
    /* 悬停效果 */
    .biddingInfo::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
    .biddingInfo>li:first-child {
        margin-top: 0;
    }
    .biddingInfo>li {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        margin-top: 8px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .biddingInfo>li>div.company, .biddingInfo>li>div.price {
        width: 200px;
    }
    .biddingInfo>li>div {
        font-size: 14px;
        color: #333;
    }
    .biddingInfo>li>div.quantity {
        width: 200px;
        white-space: nowrap;
    }
    .biddingInfo>li>div.status {
        margin-left: auto;
    }
    .biddingInfo>li>div:last-child {
        width: auto;
        margin-left: auto;
    }
    .pageWrap{
        text-align: right;
        margin: 7px 10px 0 0;
    }
    .tableWrap .price-items {
        -ms-flex-negative: 0;
        flex-shrink: 0;
        display: inline-block;
        padding: 2px 5px;
        margin: 3px 5px 3px 3px;
        border-radius: 3px;
        width: 190px;
    }
    .tableWrap .need-order-table-content{
        display: inline-block;
        white-space: nowrap;
    }
    .tableWrap .need-order-table-content .tradePrice {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
        width: 70px;
        height: 30px;
        font-weight: 700;
        color: #eb3935;
        background-color: #f8f8f8;
        border-radius: 4px;
    }
    .tableWrap .need-order-table-content div, .tableWrap .need-order-table-content span {
        white-space: nowrap;
    }
  </style>


// WEBPACK FOOTER //
// src/components/index.vue